import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { Controller } from "react-hook-form";

export function TabEncargosCLT({ empresaRaw, control, errors, methods, setTab, mdDown }: any) {
    return (
        <Box>
            <Typography variant="h6" gutterBottom paddingBottom={3}>
                Encargos CLT
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="chargesClt.fgtsPercent"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="FGTS (%)"
                                type="number"
                                error={!!errors.chargesClt?.fgtsPercent}
                                helperText={errors.chargesClt?.fgtsPercent?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="chargesClt.fgtsTerminationFine"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Multa Rescisória FGTS (%)"
                                type="number"
                                error={!!errors.chargesClt?.fgtsTerminationFine}
                                helperText={errors.chargesClt?.fgtsTerminationFine?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="chargesClt.inssEmployerPercent"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="INSS Patronal (%)"
                                type="number"
                                error={!!errors.chargesClt?.inssEmployerPercent}
                                helperText={errors.chargesClt?.inssEmployerPercent?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="chargesClt.ratPercent"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="RAT (%)"
                                type="number"
                                error={!!errors.chargesClt?.ratPercent}
                                helperText={errors.chargesClt?.ratPercent?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="chargesClt.vacationPercent"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Férias (%)"
                                type="number"
                                error={!!errors.chargesClt?.vacationPercent}
                                helperText={errors.chargesClt?.vacationPercent?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="chargesClt.thirteenthSalaryPercent"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="13º Salário (%)"
                                type="number"
                                error={!!errors.chargesClt?.thirteenthSalaryPercent}
                                helperText={errors.chargesClt?.thirteenthSalaryPercent?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="chargesClt.oneThirdVacationPercent"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="1/3 Férias (%)"
                                type="number"
                                error={!!errors.chargesClt?.oneThirdVacationPercent}
                                helperText={errors.chargesClt?.oneThirdVacationPercent?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Controller
                        name="chargesClt.fgtsOnProvisionsPercent"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="FGTS sobre Provisões (%)"
                                type="number"
                                error={!!errors.chargesClt?.fgtsOnProvisionsPercent}
                                helperText={errors.chargesClt?.fgtsOnProvisionsPercent?.message}
                                fullWidth
                                size="small"
                            />
                        )}
                    />
                </Grid>
            </Grid>
            <Box mt={2} display="flex" justifyContent="space-between">
                <Button variant="outlined" onClick={() => setTab(0)}>
                    Voltar
                </Button>
                {empresaRaw?.chargesClt !== null && (
                    <Button variant="contained" onClick={() => setTab(3)}>
                        Próximo: Configuração Orçamento
                    </Button>
                )}
            </Box>
        </Box>
    )
}